var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "8px",
    viewBox: "0 0 16 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4826054.19007457c.245415.25343276.245415.66432845 0 .91776121L4.0002434 7.8099254c-.2454151.2534328-.6433115.2534328-.8887266 0L.1840613 4.7788806c-.2454151-.25343276-.2454151-.66432844 0-.9177612.2454151-.25343276.6433115-.25343276.8887266 0l2.4830922 2.5721642L9.5938787.19007457c.2454151-.25343276.6433116-.25343276.8887267 0zm4.5714285 0c.2454151.25343276.2454151.66432845 0 .91776121L8.571672 7.8099254c-.2454151.2534328-.6433116.2534328-.8887266 0l-1.223378-1.2113113c-.2454151-.2534328-.2454151-.6643284 0-.9177612.245415-.2534328.6433115-.2534328.8887266 0l.7790147.7524307L14.1653073.19007457c.2454151-.25343276.6433116-.25343276.8887266 0z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickDouble);
export default __webpack_public_path__ + "static/media/tick-double.27fed73293193245ae680b5ac8e69836.svg";
export { ForwardRef as ReactComponent };